import React from "react";
import { useState } from "react";
import "./Counter.css";
import Button from "./Button.js"; // We make a button component with customizable color and text by passing props
function Counter() {
  {
    /* useState hook for making dynamic changes on page */
  }
  const [count, setCount] = useState(0);

  {
    /* Update functions */
  }

  const subtract = () => {
    if (count > 0) {
      setCount(count - 1);
    }
  };
  const reset = () => {
    setCount(0);
  };
  const add = () => {
    setCount(count + 1);
  };

  return (
    <div className="container">
      <div className="text">{count}</div>
      <div className="btnPanel">
        <Button color="red" text="-" onClickFunction={subtract} />
        <Button color="black" text="reset" onClickFunction={reset} />
        <Button color="green" text="+" onClickFunction={add} />
      </div>
    </div>
  );
}

export default Counter;
